// スムーススクロール
import SmoothScroll from 'smooth-scroll';
// https://github.com/cferdinandi/smooth-scroll


// スムーススクロール "window.scroll" polyfill
import smoothscroll from 'smoothscroll-polyfill';
// https://www.npmjs.com/package/smoothscroll-polyfill
// http://iamdustan.com/smoothscroll/

// "window.scroll" smooth not working on Safari
// https://stackoverflow.com/questions/51731754/window-scroll-smooth-not-working-on-safari
// Window.scroll() https://developer.mozilla.org/en-US/docs/Web/API/Window/scroll

export class Acc {
    constructor() {
        // アコーディオン複数の場合
        this.accGroups = {};
        this.toggleMenus = {};

        //その他
        this.hasAccordion = false;
        this.accMinHeight = 300;
        this.scroll = {};
    }

    getStyle(e, styleName) {
        var styleValue = "";
        if (document.defaultView && document.defaultView.getComputedStyle) {
            styleValue = document.defaultView.getComputedStyle(e, "").getPropertyValue(styleName);
        } else if (e.currentStyle) {
            styleName = styleName.replace(/\-(\w)/g, function (strMatch, p1) {
                return p1.toUpperCase();
            });
            styleValue = e.currentStyle[styleName];
        }
        return styleValue.replace(/px/g, '');
    }

    init() {
        //console.log('acc init');
        if (document.querySelectorAll('.js-acc-container')[0]) {
            this.hasAccordion = true;

            // アコーディオン複数の場合
            this.accGroups = document.querySelectorAll('.js-acc-container');
            
            [].forEach.call(this.accGroups, (elem) => {
                //console.log(elem.id);//elemは.js-acc-container

                elem.accDetail = elem.querySelector('.js-acc-details');

                // heading btn
                elem.accBtn = elem.querySelector('.js-acc-summary');
                elem.accBtn.addEventListener('click', (e) => {
                    //console.log(e.currentTarget.parentElement);
                    //this.preventDefault(e);
                    this.accClickToggle(e.currentTarget.parentElement);
                });

                // footer btn
                elem.accFooterBtn = elem.querySelector('.js-acc-footer-btn');
                elem.accFooterBtn.addEventListener('click', (e) => {
                    //console.log(e.currentTarget.parentElement);
                    this.accClickToggle(e.currentTarget.parentElement.parentElement.parentElement);
                });
            });

            //scroll
            this.scroll = new SmoothScroll();
            //this.scroll.init();
            //this.scroll.animateScroll(document.querySelector('#news'), null, options);
        }
    }

    accClickToggle(elem) {//.js-acc-container
        //console.log(elem.id);
        elem.contentHeight = elem.querySelector('.js-acc-contents').clientHeight;
        //console.log(elem + ', contentHeight=' + elem.contentHeight);
        if(elem.classList.contains('open')){
            elem.classList.remove('open');
            elem.accDetail.style.height = '0px';

            let options = {
                header: 'header',
                offset: 15,
                speed: 10,
                speedAsDuration: true,
                updateURL: false //Update the URL on scroll
            };
            this.scroll.animateScroll(elem, null, options);
        }else{
            elem.classList.add('open');
            elem.accDetail.style.height = elem.contentHeight + 'px';
        }
    }



    accResize() {
        //console.log('acc resize');

        if (this.hasAccordion) {
            //console.log('window resize -> acc1 resize');

            // アコーディオン複数の場合
            [].forEach.call(this.accGroups, (elem) => {
                elem.contentHeight = elem.querySelector('.js-acc-contents').clientHeight;
                if(elem.classList.contains('open')){
                    elem.accDetail.style.height = elem.contentHeight + 'px';
                }
            });
        }
    }

}